/** @jsxImportSource @emotion/react */
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import {
  ButtonAction,
  ButtonPrimary,
  DeleteButton,
} from "../../../components/NewButtons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { css } from "@emotion/react";
import { OverwriteMenuModalProduct } from "./OverwriteMenuModal";
import { colors } from "../../../components/colors";

type Props = {
  hiddenValue: boolean;
  isOnOriginalMenu: boolean;
  unavailableValue: boolean;
  onHiddenChange: (value: boolean) => void;
  onUnavailableChange: (value: boolean) => void;
  remove: (index: number) => void;
  product: OverwriteMenuModalProduct;
  onRemove?: () => void;
  openEditModal?: () => void;
};

export const MenuOverwriteButtonRow = ({
  hiddenValue,
  isOnOriginalMenu,
  unavailableValue,
  onHiddenChange,
  onUnavailableChange,
  remove,
  product,
  onRemove,
  openEditModal,
}: Props) => {
  const buttonPairWrapperStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 8px;
    ${openEditModal &&
    `
    padding: 8px;
    border-top: 1px dashed ${colors.greyBorder};`}
  `;

  return (
    <div css={buttonPairWrapperStyle}>
      {openEditModal && (
        <ButtonPrimary onClick={openEditModal}>
          <FontAwesomeIcon icon={solid("sliders")} />
        </ButtonPrimary>
      )}
      {isOnOriginalMenu ? (
        <>
          {!hiddenValue && (
            <DeleteButton
              disabled={unavailableValue}
              onClick={() => {
                onHiddenChange(true);
              }}
            >
              Hide
            </DeleteButton>
          )}
          {hiddenValue && (
            <ButtonAction
              backgroundColor={colors.successMedium}
              hoverColor={colors.successDark}
              textColor={colors.white}
              onClick={() => {
                onHiddenChange(false);
              }}
            >
              Show
            </ButtonAction>
          )}
          <ButtonAction
            onClick={() => {
              if (!unavailableValue) {
                onUnavailableChange(true);
                return;
              }
              onUnavailableChange(false);
            }}
            backgroundColor={
              unavailableValue ? colors.successMedium : colors.black
            }
            hoverColor={
              unavailableValue ? colors.successDark : colors.blackHover
            }
            textColor={colors.white}
            disabled={hiddenValue}
          >
            {unavailableValue ? "Mark available" : "Mark unavailable"}
          </ButtonAction>
        </>
      ) : (
        <DeleteButton
          onClick={() => {
            if (onRemove) {
              onRemove();
            }
            remove(product.fieldIndex!);
          }}
        >
          Remove
        </DeleteButton>
      )}
    </div>
  );
};
